import axios from 'axios';

// set up azure Var
let StoriesAzureAPI;
let country = window.location.href.indexOf("usa") != -1 ? 'us' : 'uk';

// Set Azzure connection
if (country == 'us') {
  StoriesAzureAPI = axios.create({
    baseURL: "https://usesstoryfunctions-apim.azure-api.net/StoryFunctions/StoryData/",
    headers: {
      "Content-type": "application/json",
      "ES-Key": "3818a8a2e8514f188a05e428e3e04dc4"
    }
  });
} else {
  StoriesAzureAPI = axios.create({
    baseURL: "https://es-stories-apim.azure-api.net/Stories/StoryData/",
    headers: {
      "Content-type": "application/json",
      "ES-Key": "b183b053fcfb429ca0dddc355c2cfb9a"
    }
  });
}

export { StoriesAzureAPI, country };
